/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tangy_Inclusive_Piranha_LaughInputs */

const fr_tangy_inclusive_piranha_laugh = /** @type {(inputs: Tangy_Inclusive_Piranha_LaughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir la page du programme`)
};

/**

* @param {Tangy_Inclusive_Piranha_LaughInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tangy_inclusive_piranha_laugh = /** @type {((inputs?: Tangy_Inclusive_Piranha_LaughInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tangy_Inclusive_Piranha_LaughInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tangy_inclusive_piranha_laugh(inputs)
});